import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from 'react'
import { ContactModal } from "../ContactModal";
import { FaLongArrowAltRight } from "react-icons/fa";
import Cards from "./Cards";
import { Main } from "./main";


function Silverfort() {

    useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const [showContactModal, setShowContactModal] = useState(false);

  const handleRequestDemo = () => {
    setShowContactModal(true);
  };

  const handleCloseContactModal = () => {
    setShowContactModal(false);
  }; 

  return (
    <>
    <div>
        <Main />
        <Cards />
    
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
         <button className="custom-button" onClick={handleRequestDemo}>
              <span>
              Request Details <FaLongArrowAltRight />
              </span>
            </button>
          </div>
    
          <ContactModal style={{zIndex:"100090"}} showModal={showContactModal} onClose={handleCloseContactModal} />
        </div>
    </>
  )
}

export default Silverfort